// eslint-disable-next-line max-len
export const wTextST = `The ordering deadline for this serving time has passed, please contact our Jungle Toppings staff directly if you want to add an order to this serving time`;
export const wTextDO = `The order is disabled due to insufficient balance. The minimum required balance is 100.000, whereas your current balance is 0.`
export const wTextDO1 = `Please top up and try again once your top up has been processed.`
